import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const Label = styled.p`
  padding: 0;
  margin: 0;
  font-size: 0.9rem;
  font-family: Montserrat;
  font-weight: 500;
  margin-bottom: 0.2rem;
`;

export const InputContainer = styled.div`
  padding: 0;
  margin: 0;
  border: 0.1rem #808080 solid;
  background-color: red;
  border-radius: 0.3rem;
  overflow: hidden;
`;

export const Input = styled.input`
  padding: 0;
  margin: 0;
  border: 0;
  padding: 0.5rem 1rem;
  width: 100%;
  font-size: 1rem;
  font-family: Montserrat;
`;